<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Квитанция об уплате
                    </v-card-title>
                    <v-card-text>
                        <div v-html="cardExportPayment.data_html"></div>
                    </v-card-text>
                    <v-card-actions
                            class="d-print-none"
                    >
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="close()">Закрыть</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'receiptExportPayment',
  data () {
    return {
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    cardExportPayment () {
      return this.$store.getters['gis_gmpExportPayment/cardExportPayment']
    }
  },
  methods: {
    close () {
      this.$router.go(-1)
    },
    initialize (newSearch = false) {
      this.$store.dispatch('gis_gmpExportPayment/fetchCardExportPayment', {
        id: this.$route.params.id
      })
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
